/**
 * ルート ID の一覧。
 *
 * TanStack Router の ID は「親 ID + パス」で機械的に決まる。認証済み画面は
 * パスを持たないレイアウトルート（`id: 'app'`）配下に置いているので、
 * 画面の ID には `/app` の接頭辞が付く（`/nodes` の ID は `/app/nodes`）。
 *
 * この文字列を各画面に直書きすると、ツリーを組み替えたときに黙って壊れる。
 * ここに集約しておけば `getRouteApi()` の型引数が `RouteIds` と突き合わせられ、
 * ずれた瞬間に tsc が落ちる。
 *
 * router.tsx を import しないのは循環参照を避けるため（画面 → router → 画面）。
 */
export const RID = {
  login: '/login',
  dashboard: '/app/',
  nodes: '/app/nodes',
  nodeDetail: '/app/nodes/$nodeId',
  organizations: '/app/organizations',
  organizationDetail: '/app/organizations/$orgId',
  domains: '/app/domains',
  domainDetail: '/app/domains/$domainId',
  mailboxes: '/app/mailboxes',
  jobs: '/app/jobs',
  jobDetail: '/app/jobs/$jobId',
  deliverability: '/app/deliverability',
  backup: '/app/backup',
  nodePools: '/app/node-pools',
  incidents: '/app/incidents',
  support: '/app/support',
  announcements: '/app/announcements',
  campaigns: '/app/campaigns',
  campaignDetail: '/app/campaigns/$campaignId',
  breakGlass: '/app/break-glass',
  ai: '/app/ai',
  slaCredits: '/app/sla-credits',
  certificates: '/app/certificates',
  webmail: '/app/webmail',
  updates: '/app/updates',
  rolloutDetail: '/app/updates/rollouts/$rolloutId',
  privacy: '/app/privacy',
  privateAddresses: '/app/private-addresses',
  security: '/app/security',
  audit: '/app/audit',
  plans: '/app/plans',
  subscriptions: '/app/subscriptions',
  invoices: '/app/invoices',
  invoiceDetail: '/app/invoices/$invoiceId',
  staff: '/app/staff',
  settings: '/app/settings',
} as const;
